import React, { useMemo } from "react";

const HeroSection = ({ invitation, primaryDateText, fontStyleMap }) => {
  const titleParts = useMemo(() => {
    if (!invitation?.title) return [];
    return invitation.title
      .split("&")
      .map((part) => part.trim())
      .filter(Boolean);
  }, [invitation?.title]);

  return (
    <section className="fw-section fw-hero">
      <div className="fw-hero-inner">
        <div
          className="fw-hero-names"
          style={{ ...(fontStyleMap.title || {}) }}
        >
          {titleParts.length >= 2 ? (
            <>
              <span>{titleParts[0]}</span>
              <span className="fw-hero-ampersand">&</span>
              <span>{titleParts.slice(1).join(" & ")}</span>
            </>
          ) : (
            <span>{invitation.title}</span>
          )}
        </div>
        {primaryDateText && (
          <div
            className="fw-hero-date"
            style={{ ...(fontStyleMap.subtitle || {}) }}
          >
            {primaryDateText}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;

